
























































// vendor
import { defineComponent, computed, ref, watch, PropType } from "@vue/composition-api";
// project
import { Asset, AssetVersion } from "@/psychlab/types/assets";
import * as AssetAPI from "@/services/api/assets";
import { formatDateStringRecent } from "@/utils/text";
// import { EditText, IEditTextModal } from "@/components.generic/utility-modal";
import { ContextMenu, IContextMenu } from "@/components.generic/context-menu";
import { Toggle } from "@/components.generic/scriptable-form";
// local
import { default as VersionListItem } from "./version-list-item.vue";

export default defineComponent({

	emits:[
		"input",
		"select",
		"restore",
	],
	props:{
		asset:{
			type:String,
			required:true,
		},
		activeVersion:{
			type:String,
		},
		disabled:{
			type:Boolean,
			default:false,
		},
		versions:{
			type:Array as PropType<AssetVersion<any>[]>,
			default:() => [],
		},
		showContext:{
			type:Boolean,
			default:true,
		},
	},
	components:{
		// EditText,
		VersionListItem,
		Toggle,
	},
	setup(props, context){

		
		const namedOnly = ref(false);

		// const editTextModal = ref<IEditTextModal>();
		// const contextMenu = ref<IContextMenu>();

		const displayVersions = computed(() => {
			if(!namedOnly.value){ return props.versions; }
			return props.versions.filter(v => Boolean(v.name));
		});

		const pickVersion = (e:Event, vid:string) => {
			context.emit("select", vid);
		};

		watch(() => props.asset, v => {
			// loadList();
		});

		return {
			formatDateStringRecent,
			pickVersion,
			namedOnly,
			displayVersions,
		};
	}
});

